// src/components/payments/PaymentBrandLogos.js
// ============================================================
// LOGOS DES MOYENS DE PAIEMENT — Maxula
// Livré par AbodyStudio Limited — https://abodystudio.com
//
// Rangée de logos (Visa, Mastercard, Cash Plus, Barid Cash…) affichée sous
// chaque mode de paiement.
//
// POURQUOI UN REPLI TEXTE AUTOMATIQUE :
// ces logos sont des marques déposées — je ne peux pas les intégrer au code,
// vous devez déposer les fichiers officiels vous-même. En attendant, chaque
// logo manquant bascule sur une pastille texte lisible : la page reste propre
// et complète, aucune image cassée. C'est la même mécanique que
// PayExpressBadge, déjà en place.
//
// OÙ DÉPOSER LES FICHIERS — dossier `client/public/payment-logos/` :
//   visa.png · mastercard.png · cashplus.png · baridcash.png
//   damanecash.png · lanacash.png · bank.png
// PNG ou SVG à fond transparent, hauteur ~40 px. Le nom du fichier doit
// correspondre exactement (minuscules, sans espace).
// ============================================================

import React, { useState } from 'react';

const Logo = ({ slug, label, height = 'h-6' }) => {
  const [failed, setFailed] = useState(false);

  if (failed) {
    return (
      <span className="inline-flex items-center px-2 py-1 rounded border border-gray-200 bg-white text-[11px] font-semibold text-gray-600 whitespace-nowrap">
        {label}
      </span>
    );
  }

  return (
    <img
      src={`/payment-logos/${slug}.png`}
      alt={label}
      title={label}
      loading="lazy"
      onError={() => setFailed(true)}
      className={`${height} w-auto object-contain`}
    />
  );
};

/**
 * @param {Array} brands  [{ slug, label }]
 */
const PaymentBrandLogos = ({ brands = [], className = '', height = 'h-6' }) => {
  if (!brands.length) return null;
  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`}>
      {brands.map((b) => (
        <Logo key={b.slug} slug={b.slug} label={b.label} height={height} />
      ))}
    </div>
  );
};

// Listes prêtes à l'emploi, pour ne pas les redéfinir à chaque écran.
export const CARD_BRANDS = [
  { slug: 'visa', label: 'Visa' },
  { slug: 'mastercard', label: 'Mastercard' },
];

export const CASH_AGENCY_BRANDS = [
  { slug: 'cashplus', label: 'Cash Plus' },
  { slug: 'baridcash', label: 'Barid Cash' },
  { slug: 'damanecash', label: 'Damane Cash' },
  { slug: 'lanacash', label: 'Lana Cash' },
];

export default PaymentBrandLogos;
